import { useEffect, useState } from 'react';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

interface DeviceWidth {
  isMobile: boolean;
  isTable: boolean;
  isSmallMobile: boolean;
  isTablet: boolean;
  isLarge: boolean;
  isXLarge: boolean;
  isLargeOrXLarge: boolean;
}

/**
 * @deprecated use "useViewportSize" instead
 */
const useDeviceWidth = (): DeviceWidth => {
  const [width, setWidth] = useState(1000);
  const handleWindowSizeChange = () => {
    setWidth(window?.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return {
    isMobile: width < ScreenSize.MEDIUM,
    isTable: width <= ScreenSize.MEDIUM,
    isSmallMobile: width < ScreenSize.SMALL,
    isTablet: width >= ScreenSize.MEDIUM && width < ScreenSize.LARGE,
    isLarge: width >= ScreenSize.LARGE,
    isXLarge: width >= ScreenSize.EXTRA_LARGE,
    isLargeOrXLarge: width >= ScreenSize.LARGE,
  };
};

export default useDeviceWidth;
